var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailInfo",
                  attrs: { noHeader: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: { title: "사업장", value: _vm.plantName },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "화학자재명",
                            value: _vm.materialName,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12 col-lg-12" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "유해ㆍ위험방지계획서 정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.mappingType,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveHazard,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "분자식",
                            name: "molecularFormula",
                          },
                          model: {
                            value: _vm.data.molecularFormula,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "molecularFormula", $$v)
                            },
                            expression: "data.molecularFormula",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "%",
                            editable: _vm.editable,
                            label: "폭발한계-상한(%)",
                            name: "explUpLimit",
                          },
                          model: {
                            value: _vm.data.explUpLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "explUpLimit", $$v)
                            },
                            expression: "data.explUpLimit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "%",
                            editable: _vm.editable,
                            label: "폭발한계-하한(%)",
                            name: "explLowLimit",
                          },
                          model: {
                            value: _vm.data.explLowLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "explLowLimit", $$v)
                            },
                            expression: "data.explLowLimit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "℃",
                            editable: _vm.editable,
                            label: "인화점(℃)",
                            name: "flashingPoint",
                          },
                          model: {
                            value: _vm.data.flashingPoint,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "flashingPoint", $$v)
                            },
                            expression: "data.flashingPoint",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "℃",
                            editable: _vm.editable,
                            label: "발화점(℃)",
                            name: "ignitionPoint",
                          },
                          model: {
                            value: _vm.data.ignitionPoint,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "ignitionPoint", $$v)
                            },
                            expression: "data.ignitionPoint",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "mmHg",
                            editable: _vm.editable,
                            label: "증기압(20℃,mmHg)",
                            name: "vaporPressure",
                          },
                          model: {
                            value: _vm.data.vaporPressure,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "vaporPressure", $$v)
                            },
                            expression: "data.vaporPressure",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 2,
                            label: "노출기준",
                            name: "exposureLimit",
                          },
                          model: {
                            value: _vm.data.exposureLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "exposureLimit", $$v)
                            },
                            expression: "data.exposureLimit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 2,
                            label: "독성치",
                            name: "toxicValue",
                          },
                          model: {
                            value: _vm.data.toxicValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "toxicValue", $$v)
                            },
                            expression: "data.toxicValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 2,
                            label: "부식성유무",
                            name: "corrosivenessFlag",
                          },
                          model: {
                            value: _vm.data.corrosivenessFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "corrosivenessFlag", $$v)
                            },
                            expression: "data.corrosivenessFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 2,
                            label: "이상반응유무",
                            name: "extraReaction",
                          },
                          model: {
                            value: _vm.data.extraReaction,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "extraReaction", $$v)
                            },
                            expression: "data.extraReaction",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "kg",
                            editable: _vm.editable,
                            label: "일일사용량(kg)",
                            name: "dailyUsage",
                          },
                          model: {
                            value: _vm.data.dailyUsage,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "dailyUsage", $$v)
                            },
                            expression: "data.dailyUsage",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "kg",
                            editable: _vm.editable,
                            label: "저장량(kg)",
                            name: "stockage",
                          },
                          model: {
                            value: _vm.data.stockage,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "stockage", $$v)
                            },
                            expression: "data.stockage",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-8" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 1,
                            label: "비고",
                            name: "remarks",
                          },
                          model: {
                            value: _vm.data.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "remarks", $$v)
                            },
                            expression: "data.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }